import { ReactNode } from 'react';

import { cn } from '@app/shared/utils/common';

interface BannerContentContainerProps {
  children: ReactNode;
  containerClassname?: string;
}

export function BannerContentContainer({
  children,
  containerClassname,
}: BannerContentContainerProps) {
  return (
    <div
      className={cn(
        'flex w-fit min-w-[160px] max-w-[90%] flex-col justify-between space-y-2 rounded-xl p-3 text-center',
        containerClassname
      )}
    >
      {children}
    </div>
  );
}
